module.exports = __webpack_public_path__ + "img/ps.e531a54e.svg";